import { Component, OnInit } from '@angular/core';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import { Color, Label } from 'ng2-charts';

import {dataLineEnergy, dataLineCost, dataLabelTime, sessionDate, stationName} from '../data0723a';

@Component({
  selector: 'app-line-chart-a',
  templateUrl: './line-chart-a.component.html',
  styleUrls: ['./line-chart-a.component.scss']
})
export class LineChartAComponent implements OnInit {

  StationName = stationName;
  SessionDate = sessionDate;

  public lineChartData: ChartDataSets[] = [
    dataLineEnergy, dataLineCost
  ];
  public lineChartLabels: Label[] = dataLabelTime;
  
  public lineChartOptions: ChartOptions = {
    responsive: true,
  };
    public lineChartColors: Color[] = [
      {
        backgroundColor: 'rgba(0,0,255,0.4)',
      borderColor: 'rgba(0,0,255,0.4)',
      },
      {
        backgroundColor: 'rgba(255,0,255,0.4)',
      borderColor: 'rgba(255,0,255,0.4)',
      }
    ];
  public lineChartLegend = true;
  public lineChartType: ChartType = 'line';
  public lineChartPlugins = [];

  constructor() { }

  ngOnInit() {
  }

}
